import { useNavigate } from "react-router-dom"
import styled from "styled-components";

const IconFut = () => (
    <svg width="51" height="36" viewBox="0 0 51 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.4137 35.0382H0L13.2524 0H50.8289L47.1384 9.89117H21.9755L20.2979 14.4177L16.7751 23.8059L12.4137 35.0382ZM22.1433 14.4177H42.4414L38.9186 23.8059H18.6205L22.1433 14.4177Z" fill="#D9D9D9"/>
    </svg>

    
  );

  export default IconFut;

